import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { PreviewState } from './ClientOnboarding.utils';
const CobConfigContext = /*#__PURE__*/ createContext(undefined);
export function CobConfigProvider(props) {
    const { relationship, children, isPreviewModal, previewState, originalPreviewState, entityContext } = props;
    const value = useMemo(()=>({
            relationship,
            isPreviewModal: !!isPreviewModal,
            isPreview: !!previewState,
            isSetupBrand: previewState === PreviewState.SetupBrand,
            originalPreviewState,
            entityContext
        }), [
        relationship,
        previewState,
        isPreviewModal,
        originalPreviewState,
        entityContext
    ]);
    return /*#__PURE__*/ _jsx(CobConfigContext.Provider, {
        value: value,
        children: children
    });
}
export function useCobConfig() {
    const context = useContext(CobConfigContext);
    if (!context) throw new Error('useCobConfig must be used within a CobConfigProvider');
    return context;
}
export function useCobConfigOptional() {
    return useContext(CobConfigContext);
}
